<template>
    <div class="ing-page page-wrapper">
        <ynk-cssgrid-layout>
            <div class="title">
                <h1>ING <br/>Jukebox</h1>
            </div>
            <div class="title-panel">
                <div class="actual-panel">
                    <h3>Digitale installatie</h3>
                    <p>Voor vertrek alvast in de vakantie&shy;stemming komen met een playlist van het land van je bestemming</p>
                </div>

                <router-link tag="button" class="view-case-button" to="/work/ing/details">View case</router-link>
            </div>
        </ynk-cssgrid-layout>

        <nav-bar></nav-bar>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import { TimelineMax } from '@/vendor';
    import CssGrid from '@/app/layouts/CssGrid';
    import NavBar from '@/app/components/NavBar';

    export default {
        name: 'IngCase',

        components: {
            'ynk-cssgrid-layout': CssGrid,
            'nav-bar': NavBar
        },

        methods: {
            getAnimateIn()
            {
                let tl = new TimelineMax();
                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();
                return tl;
            }
        }
    };
</script>
